import * as yup from 'yup';

export const MigrationApiValidation = yup.object().shape({
    toAdmin: yup.string().required(),
    customerId: yup.array().min(1, "This field can't be blank.").required("This field can't be blank."),
    fromAdmin: yup.string().optional(),
});
